export default __webpack_public_path__ + "static/media/karenPullQuote.628e7fed.wav";